export const ACTION_TYPES = {
    FILTER        : "FILTER"
}

export const saveFilter = (data) => {
    return {
        type : ACTION_TYPES.FILTER,
        ...data
    }
}

